import * as React from "react";

export interface AnimatedImageHolderComponentState {
    imageDescriptionVisible: boolean;

}

export interface AnimatedImageHolderComponentProps {
    imageUrl: string;
    title: string;
    subHeading: string;
    description: any;
    category: string;
    menuUrl: string;
    tags: string[];
    tagsOfInterest: string[];
}

export default class AnimatedImageHolderComponent extends React.Component<AnimatedImageHolderComponentProps,
    AnimatedImageHolderComponentState> {
    state: AnimatedImageHolderComponentState = {
        imageDescriptionVisible: false
    };

    public render() {
        return (
            <div
                className={"col-6 col-md-4 pfix"}
                onMouseEnter={() => this.setState(Object.assign(this.state, { imageDescriptionVisible: true }))}
                onMouseLeave={() => this.setState(Object.assign(this.state, { imageDescriptionVisible: false }))}>
                <p>
                    <img
                        alt={"placeholder"}
                        src={this.props.imageUrl}
                        className={"img-fluid shop-image-holder"} />
                </p>
                <div
                    className={
                        this.state.imageDescriptionVisible
                            ? "shop-image shop-image-open"
                            : "shop-image "
                    }>
                    <div className="row">
                        <div className="col-12">
                            <div
                                className="px-2 pb-0 pt-2 shop-image-header"
                                style={{
                                    textDecoration: "underline",
                                    fontWeight: "bold",
                                    lineHeight: 1.2
                                }}>
                                {this.props.title}
                            </div> 
                            <div className="px-2 pb-2 shop-image-sub-header">
                                {/* Pre-Security Level 3 */}
                                {this.props.subHeading}
                            </div> 
                            <p className="px-2" style={{ lineHeight: 1.2 }}
                                dangerouslySetInnerHTML={this.props.description}>
                            </p>
                            <div className="px-2 pb-2">
                            { this.props.menuUrl ? <a className={"btn btn-primary"} style={{ borderColor: "transparent", borderRadius: "10px", background: "white", color: "rgba(10,75,115)", fontWeight: "bold", fontSize: "1.7em" }}>MENU</a> : null }
                            { this.props.tags.filter(item => this.props.tagsOfInterest.indexOf(item) < 0).length < this.props.tags.length ?   <a className={"btn btn-primary"} style={{ minWidth: "91.34px", borderColor: "transparent", marginLeft: "6px", borderRadius: "10px", background: "white", color: "rgba(10,75,115)", fontWeight: "bold", fontSize: "1.7em" }}>GF/V</a> : null}

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
